<template>
    <div class="p-field" v-bind:class="props.class">
      <label :for="id" v-if="props.title">{{ props.title }}</label>

      <div class="p-field-note on-top" v-if="props.note && props.showNoteOnTop">
        <i class="pi pi-info-circle"></i>
        {{ props.note }}
      </div>

      <span v-if="props.iconLeft || props.iconRight" :class="{'p-input-icon-left': props.iconLeft, 'p-input-icon-right': props.iconRight}">
        <i :class="[props.iconLeft, props.iconRight]"></i>
        <component ref="componentRef" :is="mappedType" :id="id" :inputId="id" :class="{'p-invalid': props.error}" v-model="props.modelValue" v-bind="attrs">
          <template v-for="(_, name) in slots" v-slot:[name]="slotData">
            <slot :name="name" v-bind="slotData" />
          </template>
        </component>
      </span>

      <component ref="componentRef" v-else-if="isEditor" :is="mappedType" :id="id" :inputId="id" :class="{'p-invalid': props.error}" v-model="props.modelValue" v-bind="attrs">
        <template #toolbar>
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
          </span>
        </template>
      </component>

      <div v-else-if="isCustom" :id="id" :inputId="id" :class="{'p-invalid': props.error}" v-bind="attrs">
        <slot></slot>
      </div>

      <component ref="componentRef" v-else :is="mappedType" :id="id" :inputId="id" :class="{'p-invalid': props.error}" v-model="props.modelValue" v-bind="attrs">
        <template v-for="(_, name) in slots" v-slot:[name]="slotData">
          <slot :name="name" v-bind="slotData" />
        </template>
      </component>

      <div class="p-field-note" v-if="props.note && !props.showNoteOnTop">
        <i class="pi pi-info-circle"></i>
        {{ props.note }}
      </div>

      <div v-if="props.error" class="p-error p-mt-1">
        <small> {{ props.error }}</small>
      </div>
    </div>
</template>

<script>
const mapTypes = {
  text: 'InputText',
  email: 'InputText',
  password: 'Password',
  textarea: 'Textarea',
  editor: 'Editor',
  upload: 'FileUpload',
  multiSelect: 'MultiSelect',
  select: 'Dropdown',
  autocomplete: 'AutoComplete',
  calendar: 'Calendar',
  checkbox: 'Checkbox',
  number: 'InputNumber',
  tree: 'TreeSelect',
  custom: 'div',
}
</script>

<script setup>
import {defineProps, ref, useAttrs, useSlots} from "vue";
import {useId} from "../hooks/useId";

const props = defineProps({
  componentType: {type: String, default: 'text'},
  title: String,
  note: String,
  showNoteOnTop: Boolean,
  id: String,
  error: String,
  class: String,
  iconLeft: String,
  iconRight: String,
  modelValue: {default: ''},
})


const componentRef = ref();
const attrs = useAttrs();
const mappedType = mapTypes[props.componentType];
const id = props.id || useId();
const slots = useSlots();
const isEditor = mappedType === 'Editor';
const isCustom = props.componentType === 'custom';

defineExpose({
  component: componentRef
})
</script>

<style scoped lang="scss">
@import "../assets/sass/theme_variables";

::v-deep(.p-fileupload:not(.p-fileupload-advanced)) {
  display: flex;
  align-items: center;

  .p-message {
    margin-left: 0.5rem;
    order: 2;
  }

  .p-button {
  }
}

.p-field-note {
  display: flex;
  align-items: center;
  margin-top: toRem(12);
  font-size: toRem(14);
  color: $textThirdColor;

  .pi {
    font-size: toRem(15);
    margin-right: toRem(7);
  }

  &.on-top {
    margin-top: 0;
    margin-bottom: toRem(12);
  }
}
</style>
